// offer-details-modal.js
document.addEventListener("DOMContentLoaded", () => {
  const modal = document.getElementById("offer-details-myModal");
  const triggers = document.querySelectorAll(".detailPop");
  const closeBtn = modal.querySelector(".offer-details-close");
  let lastFocused;

  function trapFocus(e) {
    const focusable = modal.querySelectorAll(
      'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    const first = focusable[0],
      last = focusable[focusable.length - 1];
    if (e.key === "Tab") {
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function handleKeyDown(e) {
    if (e.key === "Escape") closeModal();
    else trapFocus(e);
  }

  function openModal(e) {
    e.preventDefault(); // stop the href="#"
    lastFocused = document.activeElement;
    modal.hidden = false;
    closeBtn.focus();
    document.addEventListener("keydown", handleKeyDown);
  }

  function closeModal() {
    modal.hidden = true;
    document.removeEventListener("keydown", handleKeyDown);
    lastFocused?.focus();
  }

  triggers.forEach((btn) => btn.addEventListener("click", openModal));
  closeBtn.addEventListener("click", closeModal);
  modal.addEventListener("click", (e) => {
    if (e.target === modal) closeModal();
  });
});
